// extracted by mini-css-extract-plugin
export default {"optionHeader":"optionHeader_REMd_","title":"title_F70T9","btn":"btn_HaiP2"};